module.exports = "/img/_/_/_/assets/images/creeper/book/rare//9.jpg?73d06d7d4d30ba51cbb72485dccd19b4";